// extracted by mini-css-extract-plugin
export default {"central":"createAuctionLoader_central__fA-8Y","loader":"createAuctionLoader_loader__kOWYx","load5":"createAuctionLoader_load5__rs4CE"};